'use client';

import { createContext, useContext, useState } from 'react';

const BackgroundColorContext = createContext<{
  backgroundColor: string;
  setBackgroundColor: (color: string) => void;
} | null>(null);

export function BackgroundColorProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [backgroundColor, setBackgroundColor] = useState<string>('#ffffff');

  return (
    <BackgroundColorContext.Provider
      value={{ backgroundColor, setBackgroundColor }}
    >
      {children}
    </BackgroundColorContext.Provider>
  );
}

export function useBackgroundColor() {
  const context = useContext(BackgroundColorContext);
  if (!context) {
    throw new Error(
      'useBackgroundColor must be used within a BackgroundColorProvider'
    );
  }
  return context;
}
